export default __webpack_public_path__ + "7c8ee8643ec5f8394af19f470c98c037.svg";